// extracted by mini-css-extract-plugin
export default {"panel":"panel__gQAbD","sectionHeader":"sectionHeader__GpH1P"};